/* eslint-disable import/extensions */
import deTranslations from "./de.json";
import enTranslations from "./en.json";
import esTranslations from "./es.json";
import frTranslations from "./fr.json";
import nlTranslations from "./nl.json";
import plTranslations from "./pl.json";
import ptTranslations from "./pt.json";

export const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  nl: { translation: nlTranslations },
  pl: { translation: plTranslations },
  pt: { translation: ptTranslations },
};
